module.exports = __webpack_public_path__ + "static/media/enabled-time.a33ac4c5.svg";